module.exports = __webpack_public_path__ + "static/media/activity-icon-af.5d232b65.svg";